"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSkeleton = void 0;
/* eslint-disable react/jsx-no-bind */
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const DefaultBar_1 = require("./components/DefaultBar");
const MobileBar_1 = require("./components/MobileBar");
const drawerWidth = 240;
// eslint-disable-next-line @rushstack/typedef-var
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    root: {
        display: 'flex'
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: theme.shadows[0],
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        userSelect: 'none'
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none'
        }
    },
    toolbar: {
        minHeight: 76
    },
    drawerPaper: {
        width: drawerWidth
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(2)
    },
    contentMobile: {
        flexGrow: 1,
        padding: theme.spacing(0.5)
    },
    appLogo: {
        color: theme.palette.primary.main,
        textTransform: 'none',
        fontSize: '1.1rem'
    }
}));
const AppSkeleton = (p) => {
    const props = Object.assign(Object.assign({}, p), { appName: p.appName || 'Enterprise Hub', searchBarPlaceholder: p.searchBarPlaceholder || 'Search anything...' });
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(core_1.Hidden, { smDown: true },
            react_1.default.createElement(DefaultBar_1.DefaultBar, Object.assign({}, props))),
        react_1.default.createElement(core_1.Hidden, { mdUp: true },
            react_1.default.createElement(MobileBar_1.MobileBar, Object.assign({}, props))),
        props.children && (react_1.default.createElement("div", { className: classes.content },
            react_1.default.createElement("div", { className: classes.toolbar }),
            props.children))));
};
exports.AppSkeleton = AppSkeleton;
//# sourceMappingURL=index.js.map